// # Multihash
export {};
//# sourceMappingURL=interface.js.map